import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { MediaTypeEnum, ProductDto, ProductPackageDto, ResponseDto, UserDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpProductService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/product');
	}

	saveProduct(input: ProductDto): Observable<ResponseDto> {
		return super.post(`/save`, input);
	}
	getAllProducts(input: ProductDto): Observable<ProductDto[]> {
		return super.post(`/get-all`, input);
	}
	getProductById(input: number): Observable<ProductDto> {
		return super.get(`/${input}/get-by-id`);
	}
	productAction(input: ProductDto, type: 'enable' | 'disable'): Observable<ResponseDto> {
		switch (type) {
			case 'enable':
				return super.post(`/enable`, input);
			case 'disable':
				return super.post(`/disable`, input);
			default:
				return of({success: false, error: 'Invalid action'});
		}
		
	}
}
